import React, { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import { get } from '../../utility/via-fetch';
import './legal.css';
import routeLocations from '../../utility/route-locations';


function Legal({ location }) {
  const [pageContent, setPageContent] = useState('<br/>');
  const path = location.pathname.split('/');
  useEffect(() => {
    const getHtml = async () => {
      try {
        const { content } = await get(`/api/${path[1]}/${path[2]}`, path[3] ? { versionNumber: path[3] } : {});
        setPageContent(content);
      } catch (error) {
        setPageContent(null);
      }
    };
    getHtml();
  }, [setPageContent, path]);

  if (pageContent) {
    // eslint-disable-next-line react/no-danger
    return <div className="text-box" dangerouslySetInnerHTML={{ __html: `${pageContent}` }} />;
  }
  return <Redirect to={routeLocations.notFound} />;
}

Legal.propTypes = {
  location:
    PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
};


export default withRouter(Legal);
